module.exports = __webpack_public_path__ + "static/img/splj_pic4.2.c73fcd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/videounderstand/splj_pic4.2.jpg
// module id = Gsv7
// module chunks = 0